export const SIGNED_DOCUMENT_DELETE_TOOLTIP = "Signed documents can't be deleted";

export const ROW_PADDING_LEFT_PX = 20;

export const SELECTABLE_ROW_PADDING_LEFT_PX = 5;

export const RECIPIENT_COPY_INDENT_PX = 24;
